<template>
  <div>
    <chart-card :chart-data="linechart.data"
                :chart-options="linechart.options"
                :responsive-options="linechart.responsiveOptions">
      <template slot="header">
        <h4 class="card-title">Evolution of Leads Closed</h4>
        <p class="card-category">per affiliate company</p>
      </template>
      <template slot="footer">
        <div class="legend">
          <i class="fa fa-circle text-info"></i> Lightspeed
          <i class="fa fa-circle text-danger"></i> TouchBistro
          <i class="fa fa-circle text-warning"></i> Toast
        </div>
        <hr>
        <div class="stats">
          <i class="far fa-clock"/> Last 12 Months
        </div>
      </template>
    </chart-card>
  </div>
</template>

<script>
import {ChartCard} from 'src/components/index'
export default {
  name: 'Close-Rate-Graph-Multi-View-Card',
  components: {
    ChartCard
  },
  props: {
    linechart: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      
    }
  }
}
</script>

<style>

</style>